import classNames from 'classnames';
import { Col, Row } from 'reactstrap';

const Loader = () => {
    return (
        <Row>
            <Col className="p-2 text-center">
                <div className="mx-auto my-3 loading-spinner spin-animate"></div>
            </Col>
        </Row>
    );
};

export default Loader;
